import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  var _a, _b, _c;
  const isModal = this.attr(`is-modal`);
  const showMP2023Branding = this.attr(`mp-2023-style`);
  return /* @__PURE__ */ jsx("div", null, !isModal && !showMP2023Branding && /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, "Enter Payment Info"), /* @__PURE__ */ jsx("div", {
    sel: ".payment-details-form",
    class: { "payment-info-border": !isModal }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".input-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".stripe-input.card-number"
  }, /* @__PURE__ */ jsx("label", {
    for: "cardNumber",
    sel: ".mp-font-size-medium"
  }, "Card number"), /* @__PURE__ */ jsx("div", {
    sel: "#cardNumber.input"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".error-message"
  }, (_a = this.state.errors) == null ? void 0 : _a.cardNumber)), /* @__PURE__ */ jsx("div", {
    sel: ".stripe-input.expiration"
  }, /* @__PURE__ */ jsx("label", {
    for: "cardExpiry",
    sel: ".mp-font-size-medium"
  }, "Expiration"), /* @__PURE__ */ jsx("div", {
    sel: "#cardExpiry.input"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".error-message"
  }, (_b = this.state.errors) == null ? void 0 : _b.cardExpiry))), /* @__PURE__ */ jsx("div", {
    sel: ".input-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".stripe-input.cvc"
  }, /* @__PURE__ */ jsx("label", {
    for: "cardCvc",
    sel: ".mp-font-size-medium"
  }, "CVV"), /* @__PURE__ */ jsx("div", {
    sel: "#cardCvc.input"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".error-message"
  }, (_c = this.state.errors) == null ? void 0 : _c.cardCvc)), /* @__PURE__ */ jsx("div", {
    sel: ".stripe-input.country"
  }, /* @__PURE__ */ jsx("label", {
    for: "cardCountry",
    sel: ".mp-font-size-medium"
  }, "Country"), /* @__PURE__ */ jsx(SelectEl, {
    sel: "#cardCountry",
    attrs: {
      "selected-option": this.helpers.getSelectedCountry(),
      "menu-height": 300,
      "style-override": showMP2023Branding ? `mp-button {border-radius: 100px; font-family: 'Garnett';
    font-size: 14px; letter-spacing: 0.02em; font-weight: 500;}` : ``
    },
    props: {
      sections: this.helpers.getCountriesItems()
    },
    on: { change: this.helpers.handleCountrySelectChange }
  })), this.helpers.POSTAL_CODE_COUNTRIES.has(this.state.selectedCountryCode) && /* @__PURE__ */ jsx("div", {
    sel: ".stripe-input.postal-code"
  }, /* @__PURE__ */ jsx("label", {
    for: "postal-code",
    sel: ".mp-font-size-medium"
  }, "Postal Code"), /* @__PURE__ */ jsx("input", {
    type: "text",
    sel: "#postal-code",
    class: {
      input: true,
      ...this.state.selectedPostalCode && {
        invalid: this.state.errors.postalCode,
        complete: !this.state.errors.postalCode
      }
    },
    props: { value: this.state.selectedPostalCode, placeholder: `12345` },
    on: {
      change: this.helpers.handlePostalCodeChange,
      input: this.helpers.handlePostalCodeInput
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".error-message"
  }, this.state.errors.postalCode)))), isModal ? /* @__PURE__ */ jsx("div", {
    sel: ".review-btn-area.modal"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: showMP2023Branding ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
      size: ButtonSize.Large
    },
    on: { click: () => this.dispatchEvent(new CustomEvent(`cancel-modal`)) }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: showMP2023Branding ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
      size: ButtonSize.Large,
      disabled: this.helpers.disableReviewButton()
    },
    on: { click: () => !this.helpers.disableReviewButton() && this.makeRequest() }
  }, `${this.state.reviewBtnLoading ? `Processing` : `Update`}`)) : /* @__PURE__ */ jsx(null, null, showMP2023Branding && this.attr(`show-not-charged-today`) && /* @__PURE__ */ jsx("div", {
    sel: ".info-icon-area"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` },
    sel: ".info-icon"
  }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")), /* @__PURE__ */ jsx("div", {
    sel: ".review-btn-area"
  }, this.attr(`editing-card-info`) && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: showMP2023Branding ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
      size: ButtonSize.Large
    },
    on: { click: () => this.dispatchEvent(new CustomEvent(`toggle-edit-card`)) }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: showMP2023Branding ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
      role: `button`,
      tabindex: 0,
      disabled: this.helpers.disableReviewButton(),
      size: ButtonSize.Large
    },
    on: {
      click: () => !this.helpers.disableReviewButton() && this.passSubmitPB2()
    }
  }, `${this.state.reviewBtnLoading ? `Processing` : `Review`}`), this.attr(`show-not-charged-today`) && !showMP2023Branding && /* @__PURE__ */ jsx("div", {
    sel: ".info-icon-area"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` },
    sel: ".info-icon"
  }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")))));
}
